import { ConstrainedListSearchFilterDTO } from "@landtechnologies/dtos";
import { ICheckboxFilter } from "./CheckboxFilter";

export enum ConstrainedListFilterMust {
  MATCH_ALL = "MATCH_ALL",
  MATCH_ANY = "MATCH_ANY",
  MATCH_NONE = "MATCH_NONE",
}

export interface IConstrainedListSearchFilter extends Omit<ConstrainedListSearchFilterDTO, "must" | "values"> {
  must: ConstrainedListFilterMust;
  values: ICheckboxFilter[];
  type: "checkbox";
  hideFilter?: boolean;
}
